import { Brand, createBranded } from '@deltasierra/type-utilities';

export type MediaTemplateDocumentPageId = Brand<string, 'MediaTemplateDocumentPageId'>;
export const MediaTemplateDocumentPageId = createBranded<MediaTemplateDocumentPageId>();
